/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2026-01-28 14:37:37
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-02-28 14:06:50
 * @FilePath: \vue-app-console\src\api\ToolApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Data } from '@/api/axiosFun.js';

class ToolApi {
	static getInstance() {
		if (!this.instance) this.instance = new ToolApi()
		return this.instance
	}

	async getData(url, param, method, dataType) {
		return await Data.getInstance().getData(url, param, method, dataType)
	}

	// 查询服务工具上传文件列表
	// POST /sys/file/list?page_num=&page_size=
	async getToolFileList(param, num, size) {
		const url = `/api/sys/file/list?page_num=${num}&page_size=${size}`
		return await this.getData(url, param, 'POST')
	}

	// 上传上位机升级包（APP）：/api/sys/app/upload，多文件 file[]
	async uploadApp(filesOrFormData) {
		let formData
		if (filesOrFormData instanceof FormData) {
			formData = filesOrFormData
		} else {
			formData = new FormData()
			;(filesOrFormData || []).forEach(f => formData.append('file', f))
		}
		const url = `/api/sys/app/upload`
		return await this.getData(url, formData, 'POST', 'FORM')
	}

	// 上传售后APP升级包（Service）：/api/postsale/sys/file/upload，需 category=service
	async uploadService(filesOrFormData) {
		let formData
		if (filesOrFormData instanceof FormData) {
			formData = filesOrFormData
		} else {
			formData = new FormData()
			;(filesOrFormData || []).forEach(f => formData.append('file', f))
		}
		if (!formData.has('category')) {
			formData.append('category', 'service')
		} else {
			formData.set('category', 'service')
		}
		const url = `/api/postsale/sys/file/upload`
		return await this.getData(url, formData, 'POST', 'multipart/form-data')
	}

	async editVersionContent(filesOrFormData) {
		// let formData
		// if (filesOrFormData instanceof FormData) {
		// 	formData = filesOrFormData
		// } else {
		// 	formData = new FormData()
		// 	;(filesOrFormData || []).forEach(f => formData.append('file', f))
		// }
		// if (!formData.has('category')) {
		// 	formData.append('category', 'service')
		// } else {
		// 	formData.set('category', 'service')
		// }
		const url = `/api/sys/file/update/desc`
		return await this.getData(url, filesOrFormData, 'PUT')
	}
}

export {
	ToolApi
}

